import { apiClient } from '@api';
import { Adyen } from '@quickmd-llc/design-system';

const clientKey = import.meta.env.VITE_ADYEN_CLIENT_KEY;
const envEnvironment = import.meta.env.VITE_ADYEN_ENVIRONMENT;

const environment =
  envEnvironment === 'test' || envEnvironment === 'live'
    ? envEnvironment
    : 'test';

const getBrands = async () => {
  try {
    const { data } = await apiClient.get(
      `/api/v1/payments/creditcards/methods${Adyen.getAdyenQueryString(true)}`,
    );

    return (
      (Array.isArray(data) && data.filter((x) => typeof x === 'string')) || []
    );
  } catch (error) {
    console.error(error);
    return [];
  }
};

export function useLocalAdyen() {
  return Adyen.useAdyen({
    clientKey,
    environment,
    getBrands,
  });
}
